import { FC, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { AppSettings } from "../../AppSettings";

const ViewImagePageRedirect: FC = () => {
    const { search } = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        const params = new URLSearchParams(search);

        const dir = params.get("dir");
        const file = params.get("file");
        const accessToken = params.get("accessToken");

        if (!dir || !file ) {
            navigate("/error/404", { replace: true });
            return;
        }

        const fileName = file.split(".")[0];

        var redirect = `${AppSettings.baseUrl}/gallery/${encodeURIComponent(dir)}/photo/${encodeURIComponent(fileName)}`;
        
        redirect += accessToken ? `?accessToken=${encodeURIComponent(accessToken)}` : '';

        window.location.assign(redirect);
    }, [search, navigate]);

    return null;
};

export default ViewImagePageRedirect;
